export const UB_HERO_PIPELINE_SVG = `
<svg class="ub-hero-pipeline" viewBox="0 0 560 120" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="ub-pipe" x1="0" y1="0" x2="1" y2="0">
      <stop stop-color="#2563EB"/><stop offset="1" stop-color="#10B981"/>
    </linearGradient>
    <filter id="ub-glow"><feGaussianBlur stdDeviation="3" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
  </defs>
  <g fill="#94A3B8" opacity="0.7">
    <rect x="24" y="36" width="28" height="36" rx="6" transform="rotate(-8 38 54)"/>
    <rect x="58" y="44" width="24" height="32" rx="5" transform="rotate(6 70 60)"/>
    <rect x="88" y="38" width="26" height="34" rx="5" transform="rotate(-4 101 55)"/>
  </g>
  <path d="M120 60 H200" stroke="url(#ub-pipe)" stroke-width="2" stroke-linecap="round" opacity="0.35"/>
  <circle cx="120" cy="60" r="4" fill="#2563EB"><animate attributeName="opacity" values="0.4;1;0.4" dur="2s" repeatCount="indefinite"/></circle>
  <g filter="url(#ub-glow)">
    <rect x="200" y="28" width="160" height="64" rx="16" fill="#FFFFFF" stroke="#E2E8F0" stroke-width="1.5"/>
    <rect x="216" y="44" width="128" height="8" rx="4" fill="#E2E8F0"/>
    <rect x="216" y="60" width="96" height="8" rx="4" fill="#DBEAFE"/>
    <rect x="216" y="76" width="72" height="8" rx="4" fill="#D1FAE5"/>
  </g>
  <path d="M360 60 H440" stroke="url(#ub-pipe)" stroke-width="2" stroke-linecap="round"/>
  <circle r="5" fill="#10B981" filter="url(#ub-glow)">
    <animateMotion dur="2.5s" repeatCount="indefinite" path="M120 60 H440 60"/>
  </circle>
  <g transform="translate(448 32)">
    <rect width="88" height="56" rx="14" fill="#EFF6FF" stroke="#BFDBFE" stroke-width="1.5"/>
    <ellipse cx="44" cy="28" rx="18" ry="14" fill="#2563EB" opacity="0.15"/>
    <path d="M32 36 L44 22 L56 36 Z" fill="#2563EB" opacity="0.5"/>
    <rect x="28" y="40" width="32" height="6" rx="3" fill="#2563EB" opacity="0.35"/>
  </g>
</svg>`;

function panelChrome(tag: string): string {
  return `
    <div class="ub-panel__chrome" aria-hidden="true">
      <span></span><span></span><span></span>
      <em>${tag}</em>
    </div>`;
}

export function ubIngestPanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Ingest')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="640" height="360" fill="#FFFFFF"/>
          <text x="32" y="48" font-family="system-ui,sans-serif" font-size="14" font-weight="600" fill="#0F172A">Device registration</text>
          <rect x="32" y="64" width="576" height="44" rx="10" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="48" y="78" width="160" height="16" rx="4" fill="#CBD5E1"/>
          <rect x="32" y="124" width="576" height="44" rx="10" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="48" y="138" width="200" height="16" rx="4" fill="#CBD5E1"/>
          <rect x="32" y="184" width="576" height="120" rx="12" fill="#EFF6FF" stroke="#BFDBFE"/>
          <rect x="48" y="204" width="240" height="12" rx="3" fill="#2563EB" opacity="0.35"/>
          <rect x="48" y="228" width="180" height="10" rx="3" fill="#64748B" opacity="0.3"/>
          <rect x="48" y="268" width="120" height="28" rx="999" fill="#2563EB"/>
        </svg>
      </div>
    </div>`;
}

export function ubStoragePanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Lineage')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="640" height="360" fill="#FFFFFF"/>
          <circle cx="120" cy="180" r="36" fill="#EFF6FF" stroke="#2563EB" stroke-width="2"/>
          <text x="120" y="186" text-anchor="middle" font-size="11" fill="#2563EB" font-weight="600">Device</text>
          <circle cx="320" cy="120" r="32" fill="#ECFDF5" stroke="#10B981" stroke-width="2"/>
          <text x="320" y="126" text-anchor="middle" font-size="10" fill="#10B981" font-weight="600">Task</text>
          <circle cx="320" cy="240" r="32" fill="#F8FAFC" stroke="#64748B" stroke-width="1.5"/>
          <text x="320" y="246" text-anchor="middle" font-size="10" fill="#64748B">Org</text>
          <circle cx="520" cy="180" r="40" fill="#EFF6FF" stroke="#2563EB" stroke-width="2"/>
          <text x="520" y="186" text-anchor="middle" font-size="11" fill="#2563EB" font-weight="600">Dataset</text>
          <path d="M156 180 H280" stroke="#2563EB" stroke-width="2" marker-end="url(#ub-arr)"/>
          <path d="M320 152 V208" stroke="#64748B" stroke-width="1.5" stroke-dasharray="4 4"/>
          <path d="M352 180 H480" stroke="#10B981" stroke-width="2"/>
          <defs><marker id="ub-arr" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><path d="M0,0 L8,4 L0,8 Z" fill="#2563EB"/></marker></defs>
        </svg>
      </div>
    </div>`;
}

export function ubCatalogPanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Catalog')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="640" height="360" fill="#FFFFFF"/>
          <rect x="24" y="24" width="592" height="36" rx="8" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="24" y="72" width="592" height="32" rx="6" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="40" y="82" width="120" height="12" rx="3" fill="#0F172A" opacity="0.15"/>
          <rect x="200" y="82" width="80" height="12" rx="3" fill="#64748B" opacity="0.2"/>
          <rect x="24" y="112" width="592" height="32" rx="6" fill="#EFF6FF" stroke="#BFDBFE"/>
          <rect x="40" y="122" width="140" height="12" rx="3" fill="#2563EB" opacity="0.4"/>
          <rect x="24" y="152" width="280" height="184" rx="10" fill="#F8FAFC" stroke="#E2E8F0"/>
          <rect x="320" y="152" width="296" height="184" rx="10" fill="#FFFFFF" stroke="#E2E8F0"/>
          <rect x="336" y="168" width="200" height="8" rx="2" fill="#CBD5E1"/>
          <rect x="336" y="184" width="160" height="8" rx="2" fill="#E2E8F0"/>
          <rect x="336" y="200" width="240" height="8" rx="2" fill="#E2E8F0"/>
        </svg>
      </div>
    </div>`;
}

export function ubAnalyticsPanel(): string {
  return `
    <div class="ub-panel reveal">
      ${panelChrome('Analytics')}
      <div class="ub-panel__body ub-panel__body--split">
        <svg viewBox="0 0 640 360" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="320" height="360" fill="#0F172A"/>
          <rect x="16" y="16" width="288" height="328" rx="10" fill="#1E293B"/>
          <text x="28" y="48" font-family="ui-monospace,monospace" font-size="11" fill="#94A3B8">SELECT * FROM</text>
          <text x="28" y="68" font-family="ui-monospace,monospace" font-size="11" fill="#10B981">  trajectories</text>
          <text x="28" y="88" font-family="ui-monospace,monospace" font-size="11" fill="#94A3B8">WHERE session_id =</text>
          <text x="28" y="108" font-family="ui-monospace,monospace" font-size="11" fill="#FBBF24">  'demo-042';</text>
          <rect x="336" y="0" width="304" height="360" fill="#FFFFFF"/>
          <rect x="352" y="24" width="112" height="28" rx="8" fill="#EFF6FF" stroke="#BFDBFE"/>
          <text x="368" y="43" font-size="11" fill="#2563EB" font-weight="600">SQL</text>
          <rect x="472" y="24" width="112" height="28" rx="8" fill="#ECFDF5" stroke="#A7F3D0"/>
          <text x="488" y="43" font-size="11" fill="#10B981" font-weight="600">DataFrame</text>
          <text x="352" y="78" font-family="ui-monospace,monospace" font-size="10" fill="#64748B">df = catalog.load(</text>
          <text x="352" y="94" font-family="ui-monospace,monospace" font-size="10" fill="#FBBF24">  "trajectories")</text>
          <text x="352" y="118" font-family="ui-monospace,monospace" font-size="10" fill="#64748B">df.filter(</text>
          <text x="352" y="134" font-family="ui-monospace,monospace" font-size="10" fill="#10B981">  pl.col("session")</text>
          <text x="352" y="150" font-family="ui-monospace,monospace" font-size="10" fill="#64748B">  == "demo-042")</text>
          <rect x="352" y="168" width="260" height="48" rx="12" fill="#F8FAFC" stroke="#E2E8F0"/>
          <text x="368" y="198" font-size="12" fill="#64748B" font-weight="600">AI Copilot</text>
        </svg>
      </div>
    </div>`;
}

export function ubSimPanel(): string {
  return `
    <div class="ub-panel ub-panel--compact reveal">
      ${panelChrome('Simulation')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="480" height="280" fill="#F8FAFC"/>
          <rect x="40" y="40" width="400" height="200" rx="16" fill="#FFFFFF" stroke="#E2E8F0"/>
          <line x1="240" y1="220" x2="180" y2="120" stroke="#64748B" stroke-width="4" stroke-linecap="round"/>
          <line x1="180" y1="120" x2="280" y2="100" stroke="#64748B" stroke-width="4" stroke-linecap="round"/>
          <line x1="280" y1="100" x2="320" y2="160" stroke="#64748B" stroke-width="4" stroke-linecap="round"/>
          <circle cx="240" cy="220" r="10" fill="#2563EB"/>
          <circle cx="180" cy="120" r="8" fill="#10B981"/>
          <circle cx="280" cy="100" r="8" fill="#10B981"/>
          <circle cx="320" cy="160" r="8" fill="#2563EB"/>
        </svg>
      </div>
    </div>`;
}

export function ubOrgPanel(): string {
  return `
    <div class="ub-panel ub-panel--compact reveal">
      ${panelChrome('Organization')}
      <div class="ub-panel__body">
        <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="480" height="280" fill="#FFFFFF"/>
          <rect x="32" y="32" width="416" height="40" rx="8" fill="#F8FAFC" stroke="#E2E8F0"/>
          <circle cx="56" cy="52" r="12" fill="#DBEAFE"/>
          <rect x="80" y="44" width="100" height="16" rx="4" fill="#CBD5E1"/>
          <rect x="360" y="44" width="72" height="16" rx="999" fill="#ECFDF5" stroke="#A7F3D0"/>
          <rect x="32" y="84" width="416" height="40" rx="8" fill="#FFFFFF" stroke="#E2E8F0"/>
          <circle cx="56" cy="104" r="12" fill="#E2E8F0"/>
          <rect x="80" y="96" width="120" height="16" rx="4" fill="#E2E8F0"/>
          <rect x="32" y="136" width="416" height="40" rx="8" fill="#FFFFFF" stroke="#E2E8F0"/>
          <circle cx="56" cy="156" r="12" fill="#E2E8F0"/>
          <rect x="80" y="148" width="90" height="16" rx="4" fill="#E2E8F0"/>
        </svg>
      </div>
    </div>`;
}

export function ubContrastPastSvg(): string {
  return `<svg class="ub-contrast-lines ub-contrast-lines--past" viewBox="0 0 200 120" aria-hidden="true">
    <path d="M10 20 Q60 80 110 30 T190 90" fill="none" stroke="#94A3B8" stroke-width="1.5" stroke-dasharray="6 8" opacity="0.6"/>
    <path d="M20 100 Q80 40 140 70 T180 20" fill="none" stroke="#CBD5E1" stroke-width="1.5" stroke-dasharray="4 10" opacity="0.5"/>
  </svg>`;
}

export function ubContrastNowSvg(): string {
  return `<svg class="ub-contrast-lines ub-contrast-lines--now" viewBox="0 0 200 120" aria-hidden="true">
    <defs>
      <linearGradient id="ub-now-line" x1="0" y1="0" x2="1" y2="0">
        <stop stop-color="#2563EB"/><stop offset="1" stop-color="#10B981"/>
      </linearGradient>
    </defs>
    <path d="M16 60 H184" stroke="url(#ub-now-line)" stroke-width="2.5" stroke-linecap="round"/>
    <circle cx="184" cy="60" r="6" fill="#10B981" opacity="0.8">
      <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite"/>
    </circle>
  </svg>`;
}
